/**
 * src/shell/ui/components/SettlementOverlay.tsx — 结算简报全屏浮层（设计稿 §2 Phase 6）。
 *
 * 触发：App 监听存档快照——有新项目 completed（本次会话内出现的）→ 弹出。
 * 内容：五维分、加权总分、盈亏、EXP、升级/低保如实播报（占位·待编剧）。
 * 关闭后落回桌面——此时卡带架已多一盘卡带。
 */

import { COPY } from '../../copy'
import type { Review } from '../../../gm'

export interface SettlementInfo {
  projectId: string
  review: Review
  leveledTo: number | null
  /** 本次结算触发了低保（brief §一：向父亲求援剧情事件呈现） */
  bailedOut: boolean
  bailoutTimes: number
}

export function SettlementOverlay({
  info,
  onViewReport,
  onClose,
}: {
  info: SettlementInfo
  onViewReport: (projectId: string) => void
  onClose: () => void
}) {
  const C = COPY.settlement
  const R = COPY.review
  const r = info.review
  return (
    <div className="overlay">
      <div className="panel overlay-panel">
        <h3>{C.title}</h3>
        <table className="ledger-table">
          <tbody>
            <tr><td>{R.weighted}</td><td className="mono">{r.weighted_total}</td></tr>
            <tr><td>{R.revenue}</td><td className="mono">{r.revenue}</td></tr>
            <tr><td>{R.cost}</td><td className="mono">{r.cost}</td></tr>
            <tr>
              <td>{R.profit}</td>
              <td className="mono">{r.profit >= 0 ? '+' : ''}{r.profit}</td>
            </tr>
            <tr><td>{R.exp}</td><td className="mono">+{r.exp_gained}</td></tr>
          </tbody>
        </table>
        {info.leveledTo && <p className="banner-good">{C.levelUp(info.leveledTo)}</p>}
        {info.bailedOut && <p className="banner-warn">{C.bailout(info.bailoutTimes)}</p>}
        {info.bailedOut && (
          <div className="bailout-story">
            <h4>{C.bailoutStoryTitle}</h4>
            {C.bailoutStory(info.bailoutTimes)
              .split('\n\n')
              .map((para, i) => (
                <p key={i}>{para}</p>
              ))}
          </div>
        )}
        <div className="btn-row">
          <button className="btn" type="button" onClick={() => onViewReport(info.projectId)}>
            {C.viewReport}
          </button>
          <button className="btn btn-primary" type="button" onClick={onClose}>
            {C.close}
          </button>
        </div>
      </div>
    </div>
  )
}
